/* bl-inbox-behavior.js — Shopify-Inbox-Launcher-Verhalten (Bidetlity)
   Step 1: Scroll-Hide (runter = weg, hoch = da) + Ausblenden bei Drawer/Popup.
   Bewegt/versteckt wird NUR der Activator-Button via CSS `shopify-chat::part(activator)` —
   das Chat-Panel wird NIE angefasst (verhindert den Alt-Bug „Fenster nicht schließbar").
   Panel-offen = <shopify-chat> hat `inert` NICHT. */
(function () {
  var HIDE_AFTER = 60;     // px vom Seitenanfang, in denen der Button IMMER sichtbar bleibt
  var DIR_THRESHOLD = 16;  // px, die man DURCHGEHEND in eine Richtung scrollen muss, bevor ein-/ausgeblendet
                           // wird — Anti-Flacker gegen iOS-Momentum-Nachschwingen (Richtung kippt sonst pro Frame)
  var chat = null, ticking = false, lastTop = 0, refEl = null, accum = 0;
  // Das gesamte Verhalten (Scroll-Hide, Overlay-Ausblenden, Lift, Ecken-Justage) gilt NUR mobil.
  // Auf Desktop bleibt der Chat immer sichtbar in Shopifys Naturposition — auch bei Pop-Up.
  var MOBILE = window.matchMedia('(max-width: 768px)');

  function isChat(e) { return e && e.tagName === 'SHOPIFY-CHAT'; }
  function findChat() {
    return [].slice.call(document.querySelectorAll('shopify-chat')).filter(isChat)[0] || null;
  }
  // Panel offen = der Shadow-Wrapper ist deutlich größer als der 46px-Button (zuverlässig,
  // im Gegensatz zum `inert`-Attribut, das mobil im geschlossenen Zustand fehlt).
  function panelOpen() {
    if (!chat || !chat.shadowRoot) return false;
    var w = chat.shadowRoot.querySelector('#shopify-element-wrapper')
         || chat.shadowRoot.querySelector('[part="container"], [class*="panel" i], [class*="conversation" i]');
    if (!w) return false;
    return w.getBoundingClientRect().height > 120;
  }

  // Scroll-Erkennung container-unabhängig: top() eines stabilen Elements via getBoundingClientRect
  // wird beim Runterscrollen negativer — egal ob window/body/ein anderer Container scrollt.
  function top() {
    if (!refEl || !refEl.isConnected) {
      refEl = document.querySelector('main, #MainContent, .main-content, .Pro_content') || document.body;
    }
    return refEl ? refEl.getBoundingClientRect().top : 0;
  }

  function isVisible(el) {
    if (!el) return false;
    if (el.getAttribute('aria-hidden') === 'true') return false;
    var c = getComputedStyle(el);
    if (c.display === 'none' || c.visibility === 'hidden' || parseFloat(c.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 2 && r.height > 2;
  }
  function overlayOpen() {
    // Drawer (Warenkorb/Menü/Suche): Theme setzt body.sidebar-move
    if (document.body.classList.contains('sidebar-move')) return true;
    // Quick-Add-Popup
    if (document.querySelector('.qa.is-open')) return true;
    // sonstige sichtbare Overlays (Quick-Add-Overlay, Newsletter/Discount-Popup, offene Drawer)
    var els = document.querySelectorAll('.qa-overlay, sidebar-drawer, modal-box#modal-popup, [data-quick-add]');
    for (var i = 0; i < els.length; i++) { if (isVisible(els[i])) return true; }
    return false;
  }
  function applyOverlay() { if (chat) chat.classList.toggle('bl-inbox--suppressed', MOBILE.matches && overlayOpen()); }

  // ===== Position: EINE einzige JS-gesteuerte translateY (--bl-inbox-y) =====
  // Statt drei konkurrierender Transforms (natürlich / angehoben / versteckt) gibt es genau EINE
  // Ruhelage, die sichtbar nur zwischen „oben natürlich" und „unten fix über der Sticky-Leiste"
  // wechselt — und dieser Wechsel passiert eingefroren + nur während der Button unsichtbar ist,
  // sodass man kein Hüpfen/Ruckeln sieht. Verstecken = Opacity 0 + kleiner Tuck nach unten.
  var LIFT_GAP = 10;        // px Abstand: Button-Unterkante über Oberkante der Sticky-Leiste
  var HIDE_TUCK = 0;        // 0 = reines Ausblenden ohne vertikale Bewegung (kein „Hüpfen")
  var REST_BOTTOM = 24;     // px Ziel-Abstand zum unteren Rand auf Seiten OHNE Sticky-CTA (untere rechte Ecke).
                            // Shopify parkt den Launcher sonst ~148px zu hoch -> hier nach unten rechts ziehen.
  var natBottomOffset = null; // natürliche Button-Unterkante (Abstand vom unteren Rand), ohne Lift gemessen
  var lifted = false;         // Ruhelage: false = natürlich unten, true = angehoben über Sticky-Leiste
  var frozenLift = 0;         // EINGEFRORENER Lift (px) — ändert sich nicht pro Frame -> stabile Position

  function stickyBar() {
    var b = document.querySelector('.addtonew.bl-sticky-on') || document.querySelector('.bl-dlx-sticky.show');
    return (b && isVisible(b)) ? b : null;
  }
  // Launcher-Button im Shadow-DOM (mit „Chat"-Label) — für die Positionsmessung.
  function launcherEl() {
    if (!chat || !chat.shadowRoot) return null;
    return chat.shadowRoot.querySelector('[part~="activator"]')
        || chat.shadowRoot.querySelector('button, [role="button"], a[href]');
  }
  function isHiddenNow() {
    return chat.classList.contains('bl-inbox--hidden')
        || chat.classList.contains('bl-inbox--suppressed');
  }
  function measureNatBottom() {
    if (lifted) return; // im angehobenen Zustand wäre die Messung verfälscht
    var l = launcherEl();
    if (!l) return;
    var r = l.getBoundingClientRect();
    if (r.height <= 0) return;
    // WICHTIG: die aktuell angewandte Verschiebung (--bl-inbox-y, z.B. die Ecken-Justage) wieder
    // herausrechnen — sonst misst man die schon verschobene Position und der Wert driftet (Feedback-Schleife).
    var appliedY = parseFloat(chat.style.getPropertyValue('--bl-inbox-y')) || 0;
    natBottomOffset = window.innerHeight - r.bottom + appliedY;
  }
  // Lift so, dass die Button-Unterkante LIFT_GAP px über der Sticky-Leiste sitzt (Höhe egal).
  function computeLift() {
    var bar = stickyBar();
    if (!bar) return frozenLift;
    var nb = (natBottomOffset != null) ? natBottomOffset : 20;
    var naturalBottomFromTop = window.innerHeight - nb;
    var L = naturalBottomFromTop - bar.getBoundingClientRect().top + LIFT_GAP;
    return (L > 0) ? Math.round(L) : 0;
  }
  // Die EINE Position schreiben. baseY = Ruhelage (0 oben / -frozenLift unten); versteckt -> wegtauchen.
  function render() {
    var baseY;
    if (lifted) {
      baseY = -frozenLift;                              // über der Sticky-CTA
    } else if (natBottomOffset != null && natBottomOffset > REST_BOTTOM) {
      baseY = natBottomOffset - REST_BOTTOM;            // ohne Sticky-CTA: in die untere rechte Ecke ziehen
    } else {
      baseY = 0;                                        // Fallback: Shopify-Naturposition
    }
    var y = isHiddenNow() ? (baseY + HIDE_TUCK) : baseY;
    chat.style.setProperty('--bl-inbox-y', Math.round(y) + 'px');
  }
  // Lift-Zustand mit Hysterese: EINMAL anheben sobald die Sticky-Leiste erscheint (passiert beim
  // Runterscrollen -> Button ohnehin schon ausgeblendet), Wert einfrieren; erst ganz oben wieder ablegen.
  // Kurzzeitiges Sticky-An/Aus am Trigger-Rand ändert die Position NICHT -> kein Flackern.
  function updateLiftState(offset) {
    measureNatBottom();
    if (offset <= HIDE_AFTER) {
      lifted = false;                       // ganz oben: natürliche Ruhelage
    } else if (stickyBar()) {
      if (!lifted) { frozenLift = computeLift(); lifted = true; }   // Wert EINMAL einfrieren
      else if (isHiddenNow()) { frozenLift = computeLift(); }       // still nachjustieren (unsichtbar)
    }
    // lifted bleibt sonst unverändert (Hysterese: Leiste kann kurz verschwinden, Position bleibt)
  }

  // ---- Debug-Overlay (nur mit ?inboxdebug) ----
  var DBG = /inboxdebug/.test(location.search);
  var dbgEl = null, frames = 0, winEv = 0, docEv = 0;
  if (DBG) {
    dbgEl = document.createElement('div');
    dbgEl.style.cssText = 'position:fixed;top:0;left:0;z-index:2147483647;background:#000;color:#0f0;font:11px monospace;padding:4px 6px;white-space:pre;pointer-events:none;max-width:70vw;';
    (document.body || document.documentElement).appendChild(dbgEl);
    window.addEventListener('scroll', function(){ winEv++; }, { passive:true });
    document.addEventListener('scroll', function(){ docEv++; }, { capture:true, passive:true });
  }

  // rAF-Loop statt Scroll-Events: prüft jeden Frame die Position — feuert zuverlässig auch auf iOS
  // Safari (wo Scroll-Events während des Momentum-Scrollens oft nicht/gedrosselt kommen).
  function frame() {
    frames++;
    // Desktop: Chat immer sichtbar, Naturposition — kein Scroll-Hide/Overlay-Suppress/Lift.
    if (!MOBILE.matches) {
      chat.classList.remove('bl-inbox--hidden');
      chat.classList.remove('bl-inbox--suppressed');
      lifted = false;
      chat.style.setProperty('--bl-inbox-y', '0px');
      raf = requestAnimationFrame(frame);
      return;
    }
    var t = top();
    var offset = -t; // ~ Scroll-Position von oben
    var delta = t - lastTop; // < 0 = runtergescrollt, > 0 = hochgescrollt
    if (Math.abs(delta) > 0.5) {
      if (!panelOpen()) {
        if (offset <= HIDE_AFTER) {
          chat.classList.remove('bl-inbox--hidden'); // ganz oben -> immer da
          accum = 0;
        } else {
          // Bewegung in EINE Richtung aufsummieren; ein Richtungswechsel setzt den Zähler zurück.
          // So kippt der Zustand erst nach einer bewussten Scrollstrecke (>DIR_THRESHOLD) — winziges
          // Momentum-Nachschwingen (−3,+2,−3,…) erreicht die Schwelle nie und flackert daher nicht.
          if ((delta < 0) !== (accum < 0)) accum = 0;
          accum += delta;
          if (accum <= -DIR_THRESHOLD) { chat.classList.add('bl-inbox--hidden'); accum = 0; }       // runter -> weg
          else if (accum >= DIR_THRESHOLD) { chat.classList.remove('bl-inbox--hidden'); accum = 0; } // hoch -> da
        }
      } else {
        chat.classList.remove('bl-inbox--hidden'); // Panel offen -> nie verstecken
        accum = 0;
      }
      lastTop = t;
    }
    updateLiftState(offset); // Ruhelage (natürlich/angehoben) mit Hysterese bestimmen
    render();                // die EINE Position schreiben
    if (DBG && dbgEl) {
      var adSticky = document.querySelector('.addtonew.bl-sticky-on') ? 'Y' : 'N';
      dbgEl.textContent = 'frames:' + frames + ' off:' + Math.round(offset)
        + '\nblSticky:' + adSticky + ' lifted:' + lifted + ' frozenLift:' + frozenLift
        + '\nhidden:' + chat.classList.contains('bl-inbox--hidden')
        + ' y:' + (chat.style.getPropertyValue('--bl-inbox-y') || '0');
    }
    raf = requestAnimationFrame(frame);
  }
  var raf = null;
  function startLoop() { if (raf == null) raf = requestAnimationFrame(frame); }
  function stopLoop() { if (raf != null) { cancelAnimationFrame(raf); raf = null; } }

  function init() {
    lastTop = top();
    chat.classList.add('bl-inbox');
    startLoop();
    // im Hintergrund-Tab pausieren (Akku schonen)
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopLoop(); else { lastTop = top(); startLoop(); }
    });

    // Overlays (Drawer/Popup/Quick-Add) beobachten — reagiert auf class/aria/style + neu eingefügte Nodes
    new MutationObserver(applyOverlay).observe(document.body, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['class', 'aria-hidden', 'style']
    });
    applyOverlay();

    // Panel-Statuswechsel: beim Öffnen alles einblenden (Launcher + Panel sichtbar & bedienbar)
    new MutationObserver(function () {
      if (panelOpen()) {
        chat.classList.remove('bl-inbox--hidden');
        chat.classList.remove('bl-inbox--suppressed');
      } else {
        applyOverlay();
      }
    }).observe(chat, { attributes: true, attributeFilter: ['inert', 'aria-hidden', 'view'] });
  }

  chat = findChat();
  if (chat) {
    init();
  } else {
    var obs = new MutationObserver(function () {
      var el = findChat();
      if (el) { chat = el; obs.disconnect(); init(); }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
